import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { CsvAsStringArrays } from '@malou-io/package-utils';

import { ChartReviewsStats } from '#modules/reviews/models/chart-reviews-stats';
import { AbstractCsvService } from '#modules/statistics/components/download-insights-modal/models/csv-service.abstract';
import { AggregatedStatisticsStore } from '#modules/statistics/stores/aggregated-store/aggregated-statistics.store';

type Data = ChartReviewsStats[];

@Injectable()
export class AggregatedReviewCountCsvInsightsService extends AbstractCsvService<Data> {
    private readonly _aggregatedStatisticsStore = inject(AggregatedStatisticsStore);

    protected override _isDataValid(data: Data): boolean {
        return data.length !== 0;
    }

    protected override _getData$(): Observable<Data> {
        return of(this._aggregatedStatisticsStore.reviewCountsData());
    }

    protected override _getCsvDataRows(data: Data): CsvAsStringArrays {
        return data.map((d) => {
            const restaurantName = d.restaurant.name;
            const restaurantInternalName = d.restaurant.internalName ?? '';
            const restaurantAddress = d.restaurant.address?.getFullFormattedAddress() ?? '';
            const reviewsCount = typeof d.totalReviews === 'number' ? d.totalReviews.toString() : '';
            return [restaurantName, restaurantInternalName, restaurantAddress, reviewsCount];
        });
    }

    protected override _getCsvHeaderRow(): CsvAsStringArrays[0] {
        return ['Location', 'Location Internal Name', 'Location Address', 'Review Count'];
    }
}
